import { render } from "./AddTile.vue?vue&type=template&id=217bf93e&lang=pug"
import script from "./AddTile.vue?vue&type=script&lang=js"
export * from "./AddTile.vue?vue&type=script&lang=js"

import "./AddTile.vue?vue&type=style&index=0&id=217bf93e&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__